import { STORAGE_KEYS as s } from "./storage-manager.js";
export function getAlias(e) {
  var t = null == e ? void 0 : e.lt(s.ct.uE);
  var n;
  return t && (n = {
    label: t.l,
    name: t.a
  }), n;
}